
// import { useState, useEffect } from "react";
// import axios from "axios";
// import { useNavigate } from "react-router-dom";
// import {
//   Box, Container, Typography, Stepper, Step, StepLabel, Grid, Card, CardActionArea,
//   Button, TextField, MenuItem, Divider, Alert, CircularProgress, Paper, Stack, IconButton,
//   Accordion, AccordionSummary, AccordionDetails, Chip,
// } from "@mui/material";
// import ArrowBackIcon from "@mui/icons-material/ArrowBack";
// import AddIcon from "@mui/icons-material/Add";
// import RemoveIcon from "@mui/icons-material/Remove";
// import CheckCircleIcon from "@mui/icons-material/CheckCircle";
// import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
// import CheckroomIcon from "@mui/icons-material/Checkroom";
// import EditIcon from "@mui/icons-material/Edit";
// import CloseIcon from "@mui/icons-material/Close";
// import { fetchUserFromRedis } from "../HomePage/AuthonticationScreens/Register";

// const API = process.env.REACT_APP_API_LAUNDRY_URL;
// const authHeaders = () => ({ headers: { Authorization: `Bearer ${sessionStorage.getItem("token")}` } });
// const TEAL = "#006D77";
// const TEAL_LIGHT = "#E0F7F8";
// const STEPS = ["Service", "Items", "Pickup", "Schedule", "Pay"];
// const TIME_SLOTS = ["7-9 AM", "9-11 AM", "11 AM-1 PM", "2-4 PM", "4-6 PM"];
// const DELIVERY_CHARGE = 0;

// const SERVICE_CARD_HEIGHT = 300;
// const SERVICE_IMAGE_HEIGHT = 200;

// const LaundryBooking = () => {
//   const navigate = useNavigate();
//   const community = sessionStorage.getItem("community") || "";

//   const [step, setStep] = useState(0);
//   const [error, setError] = useState("");
//   const [loading, setLoading] = useState(false);
//   const [confirmed, setConfirmed] = useState(null);

//   const [services, setServices] = useState([]);
//   const [selService, setSelService] = useState(null);
//   const [items, setItems] = useState([]);
//   const [prices, setPrices] = useState([]);
//   const [qty, setQty] = useState({});
//   const [expandedCat, setExpandedCat] = useState(null);

//   // ─── Pickup / address state ────────────────────────────────────────────────
//   const [form, setForm] = useState({
//     patient_name: "", phone: "",
//     community_name: "", address_line1: "", address_line2: "", pincode: "",
//     pickup_address: "", // final joined string sent to backend
//     pickup_date: "", pickup_time: "", delivery_date: "", delivery_time: "", notes: "",
//   });
//   const [isEditingAddress, setIsEditingAddress] = useState(false);
//   const [originalFormData, setOriginalFormData] = useState(null);
//   const [userLoading, setUserLoading] = useState(true);

//   const [walletBalance, setWalletBalance] = useState(0);
//   const [useWallet, setUseWallet] = useState(false);
//   const [paymentMethod, setPaymentMethod] = useState("cash");
//   const [razorpayLoaded, setRazorpayLoaded] = useState(false);

//   // ─── Load services + wallet + razorpay ─────────────────────────────────────
//   useEffect(() => {
//     axios.get(`${API}/booking/services`, { ...authHeaders(), params: { community } })
//       .then((r) => setServices(r.data || [])).catch(() => {});

//     axios.get(`${process.env.REACT_APP_REFERRAL_API}/referral/summary`, authHeaders())
//       .then((r) => setWalletBalance(r.data?.wallet_balance || 0)).catch(() => {});

//     if (window.Razorpay) setRazorpayLoaded(true);
//     else {
//       const s = document.createElement("script");
//       s.src = process.env.REACT_APP_RAZORPAY_SCRIPT; s.async = true;
//       s.onload = () => setRazorpayLoaded(true);
//       document.body.appendChild(s);
//     }
//     /* eslint-disable-next-line */
//   }, []);

//   // ─── Prefill pickup details from logged-in user's saved address ───────────
//   useEffect(() => {
//     const loadUser = async () => {
//       const userId = sessionStorage.getItem("userId");
//       const token = sessionStorage.getItem("token");
//       if (!userId || !token) { setUserLoading(false); return; }
//       try {
//         const userData = await fetchUserFromRedis(userId, token);
//         if (userData) {
//           const addr = userData.address || {};
//           const rawPhone = (addr.phone || userData.phone || "").replace(/\D/g, "");
//           const phone = rawPhone.length === 12 && rawPhone.startsWith("91") ? rawPhone.slice(2) : rawPhone;
//           const joined = [addr.address_line1, addr.address_line2, addr.community_name]
//             .filter(Boolean).join(", ");
//           setForm((prev) => ({
//             ...prev,
//             patient_name: addr.full_name || userData.name || "",
//             phone,
//             community_name: addr.community_name || "",
//             address_line1: addr.address_line1 || "",
//             address_line2: addr.address_line2 || "",
//             pincode: addr.pincode || "",
//             pickup_address: joined,
//           }));
//           // If there's no saved address at all, open the editor by default
//           if (!addr.address_line1) setIsEditingAddress(true);
//         } else {
//           setIsEditingAddress(true);
//         }
//       } catch {
//         setIsEditingAddress(true);
//       } finally {
//         setUserLoading(false);
//       }
//     };
//     loadUser();
//   }, []);

//   const pickService = async (svc) => {
//     setSelService(svc); setError("");
//     try {
//       const [itRes, prRes] = await Promise.all([
//         axios.get(`${API}/booking/items`, { ...authHeaders(), params: { community } }),
//         axios.get(`${API}/booking/prices`, { ...authHeaders(), params: { community, service: svc.name } }),
//       ]);
//       setItems(itRes.data || []); setPrices(prRes.data || []);
//       const firstCat = (itRes.data || [])[0]?.category || null;
//       setExpandedCat(firstCat);
//       setStep(1);
//     } catch { setError("Could not load items."); }
//   };

//   const priceOf = (n) => prices.find((p) => p.item === n)?.price || 0;
//   const setItemQty = (name, delta) => setQty((prev) => {
//     const next = Math.max(0, (prev[name] || 0) + delta);
//     const c = { ...prev }; if (next === 0) delete c[name]; else c[name] = next; return c;
//   });

//   const orderItems = Object.entries(qty).map(([name, q]) => {
//     const it = items.find((x) => x.name === name); const price = priceOf(name);
//     return { category: it?.category, item: name, quantity: q, price, total: q * price };
//   });
//   const subtotal = orderItems.reduce((s, i) => s + i.total, 0);
//   const totalItemCount = orderItems.reduce((s, i) => s + i.quantity, 0);
//   const walletApplied = useWallet ? Math.min(walletBalance, subtotal + DELIVERY_CHARGE) : 0;
//   const total = Math.max(0, subtotal + DELIVERY_CHARGE - walletApplied);

//   // ─── Address helpers ────────────────────────────────────────────────────
//   const handleAddressChange = (field, value) => setForm((prev) => ({ ...prev, [field]: value }));
//   const openEditAddress = () => { setOriginalFormData({ ...form }); setIsEditingAddress(true); };
//   const cancelEditAddress = () => {
//     if (originalFormData) setForm(originalFormData);
//     setIsEditingAddress(false);
//   };
//   const saveAddress = () => {
//     const joined = [form.address_line1, form.address_line2, form.community_name]
//       .filter(Boolean).join(", ");
//     setForm((prev) => ({ ...prev, pickup_address: joined }));
//     setIsEditingAddress(false);
//   };

//   const buildPayload = (extra = {}) => ({
//     community, service_type: selService.name, items: orderItems,
//     pickup_address: form.pickup_address, pickup_date: form.pickup_date, pickup_time: form.pickup_time,
//     delivery_date: form.delivery_date, delivery_time: form.delivery_time,
//     subtotal, delivery_charge: DELIVERY_CHARGE, discount: 0, wallet_amount: walletApplied, tax: 0,
//     patient_name: form.patient_name, phone: form.phone, notes: form.notes, ...extra,
//   });

//   const placeOrder = async () => {
//     const miss = [];
//     if (!form.patient_name) miss.push("Name");
//     if (!form.phone) miss.push("Phone");
//     if (!form.pickup_address) miss.push("Pickup address");
//     if (!form.pickup_date) miss.push("Pickup date");
//     if (!form.delivery_date) miss.push("Delivery date");
//     if (orderItems.length === 0) miss.push("At least one item");
//     if (miss.length) { setError(`Please provide: ${miss.join(", ")}`); return; }
//     setError(""); setLoading(true);

//     if (paymentMethod === "cash" || (useWallet && total === 0)) {
//       try {
//         const res = await axios.post(`${API}/booking/orders`,
//           buildPayload({ payment_method: useWallet && total === 0 ? "wallet" : "cash" }), authHeaders());
//         setConfirmed(res.data);
//       } catch { setError("Could not place order. Please try again."); }
//       finally { setLoading(false); }
//       return;
//     }

//     if (!razorpayLoaded || !window.Razorpay) { setError("Payment gateway loading, try again."); setLoading(false); return; }
//     try {
//       const orderRes = await axios.post(`${API}/booking/orders`, buildPayload({ payment_method: "online" }), authHeaders());
//       const created = orderRes.data;
//       const rzpOrder = await axios.post(process.env.REACT_APP_CREATE_RAZORPAY_ORDER, {
//         amount: total, currency: "INR", receipt: created.order_code,
//         service_type: "laundry", customer_name: form.patient_name, contact: form.phone,
//       });
//       setLoading(false);
//       const rzp = new window.Razorpay({
//         key: process.env.REACT_APP_RAZORPAY_KEY, currency: "INR",
//         name: "Ayuja Laundry", description: selService.name, order_id: rzpOrder.data.id,
//         prefill: { name: form.patient_name, contact: form.phone }, theme: { color: TEAL },
//         handler: async (resp) => {
//           setLoading(true);
//           try {
//             const verify = await axios.post(process.env.REACT_APP_PROCESS_PAYEMENT, {
//               razorpay_payment_id: resp.razorpay_payment_id,
//               razorpay_order_id: resp.razorpay_order_id,
//               razorpay_signature: resp.razorpay_signature,
//             });
//             if (!verify.data?.verified) throw new Error("verify failed");
//             const conf = await axios.post(`${API}/booking/orders/confirm-payment`, {
//               order_id: created.id,
//               razorpay_order_id: resp.razorpay_order_id,
//               razorpay_payment_id: resp.razorpay_payment_id,
//             }, authHeaders());
//             setConfirmed(conf.data);
//           } catch { setError("Payment received but confirmation failed. Contact support."); }
//           finally { setLoading(false); }
//         },
//         modal: { ondismiss: () => { setLoading(false); setError("Payment cancelled."); } },
//       });
//       rzp.on("payment.failed", (r) => { setLoading(false); setError(`Payment failed: ${r.error?.description || ""}`); });
//       rzp.open();
//     } catch { setError("Could not start payment."); setLoading(false); }
//   };

//   const back = () => { setError(""); setStep((s) => Math.max(0, s - 1)); };
//   if (confirmed) return <Confirmation order={confirmed} onDone={() => navigate("/laundry-service")} />;

//   const grouped = items.reduce((acc, it) => { (acc[it.category] = acc[it.category] || []).push(it); return acc; }, {});
//   const categoryCount = (cat) => (grouped[cat] || []).reduce((s, it) => s + (qty[it.name] || 0), 0);
//   const categorySubtotal = (cat) => (grouped[cat] || []).reduce((s, it) => s + (qty[it.name] || 0) * priceOf(it.name), 0);

//   return (
//     <Container maxWidth="md" sx={{ py: { xs: 3, sm: 5 }, px: { xs: 2, sm: 3 }, pb: step === 1 ? 12 : 5 }}>
//       {step < 4 && (
//         <Button startIcon={<ArrowBackIcon />} onClick={step > 0 ? back : () => navigate(-1)}
//           sx={{ mb: 2, textTransform: "none", color: TEAL, fontWeight: 600 }}>Back</Button>
//       )}

//       {step < 4 && (
//         <>
//           <Typography variant="h4" fontWeight={800} color={TEAL} gutterBottom
//             sx={{ fontSize: { xs: "1.7rem", sm: "2.125rem" } }}>Book Laundry Service</Typography>
//           <Typography color="text.secondary" mb={4}>Pickup · Wash · Delivered to your door</Typography>

//           <Stepper activeStep={step} alternativeLabel sx={{ mb: 4, "& .MuiStepLabel-label": { fontSize: { xs: 11, sm: 14 } } }}>
//             {STEPS.map((l) => <Step key={l}><StepLabel>{l}</StepLabel></Step>)}
//           </Stepper>

//           {error && <Alert severity="error" sx={{ mb: 3 }}>{error}</Alert>}
//         </>
//       )}

//       {/* Step 0: Service — fixed-size 2-per-row cards */}
//       {step === 0 && (
//         <Grid container spacing={2.5}>
//           {services.map((svc) => (
//             <Grid item xs={12} sm={6} key={svc.id}>
//               <Card
//                 variant="outlined"
//                 sx={{
//                   borderRadius: 3, overflow: "hidden", height: SERVICE_CARD_HEIGHT,
//                   display: "flex", flexDirection: "column", transition: "all .15s ease",
//                   "&:hover": { borderColor: TEAL, boxShadow: 4, transform: "translateY(-2px)" },
//                 }}
//               >
//                 <CardActionArea
//                   onClick={() => pickService(svc)}
//                   sx={{ height: "100%", display: "flex", flexDirection: "column", alignItems: "stretch" }}
//                 >
//                   <Box sx={{ height: SERVICE_IMAGE_HEIGHT, flexShrink: 0, bgcolor: TEAL_LIGHT, position: "relative" }}>
//                     {svc.image_url
//                       ? <Box component="img" src={svc.image_url} alt={svc.name}
//                           sx={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }} />
//                       : <Box sx={{ height: "100%", display: "flex", alignItems: "center", justifyContent: "center" }}>
//                           <CheckroomIcon sx={{ fontSize: 48, color: TEAL, opacity: 0.6 }} />
//                         </Box>}
//                   </Box>
//                   <Box
//                     p={2}
//                     sx={{ flex: 1, display: "flex", flexDirection: "column", justifyContent: "center", width: "100%", minWidth: 0 }}
//                   >
//                     <Typography fontWeight={700} noWrap>{svc.name}</Typography>
//                     <Typography
//                       variant="body2" color="text.secondary"
//                       sx={{ display: "-webkit-box", WebkitLineClamp: 2, WebkitBoxOrient: "vertical", overflow: "hidden", mt: 0.5 }}
//                     >
//                       {svc.description}
//                     </Typography>
//                   </Box>
//                 </CardActionArea>
//               </Card>
//             </Grid>
//           ))}
//           {services.length === 0 && <Grid item xs={12}><Typography color="text.secondary">No services available.</Typography></Grid>}
//         </Grid>
//       )}

//       {/* Step 1: Items — collapsible category accordions with a pinned summary bar */}
//       {step === 1 && (
//         <Box>
//           <Typography variant="h6" fontWeight={700} mb={2}>{selService?.name} — choose items</Typography>

//           <Stack spacing={1.5}>
//             {Object.entries(grouped).map(([cat, list]) => {
//               const isOpen = expandedCat === cat;
//               const count = categoryCount(cat);
//               return (
//                 <Accordion
//                   key={cat}
//                   expanded={isOpen}
//                   onChange={() => setExpandedCat(isOpen ? null : cat)}
//                   disableGutters
//                   variant="outlined"
//                   sx={{ borderRadius: "12px !important", overflow: "hidden", "&:before": { display: "none" }, borderColor: isOpen ? TEAL : "#E2E8F0" }}
//                 >
//                   <AccordionSummary
//                     expandIcon={<ExpandMoreIcon sx={{ color: isOpen ? TEAL : "inherit" }} />}
//                     sx={{ bgcolor: isOpen ? TEAL_LIGHT : "#FAFAFA", px: 2.5, "& .MuiAccordionSummary-content": { alignItems: "center", gap: 1.5 } }}
//                   >
//                     <Typography fontWeight={700} color={isOpen ? TEAL : "text.primary"}>{cat}</Typography>
//                     <Chip label={`${list.length} items`} size="small" variant="outlined" sx={{ borderColor: "#CBD5E1" }} />
//                     {count > 0 && (
//                       <Chip
//                         label={`${count} selected · ₹${categorySubtotal(cat)}`}
//                         size="small"
//                         sx={{ bgcolor: TEAL, color: "#fff", fontWeight: 700, ml: "auto !important" }}
//                       />
//                     )}
//                   </AccordionSummary>
//                   <AccordionDetails sx={{ p: 2, bgcolor: "#fff" }}>
//                     <Stack spacing={1}>
//                       {list.map((it) => {
//                         const p = priceOf(it.name);
//                         const q = qty[it.name] || 0;
//                         return (
//                           <Paper
//                             key={it.id}
//                             variant="outlined"
//                             sx={{
//                               p: 1.5, borderRadius: 2, display: "flex", alignItems: "center", justifyContent: "space-between",
//                               borderColor: q > 0 ? TEAL : "#E2E8F0", bgcolor: q > 0 ? "#F5FCFC" : "#fff",
//                             }}
//                           >
//                             <Box display="flex" alignItems="center" gap={1.5} minWidth={0}>
//                               <Box sx={{ width: 40, height: 40, flexShrink: 0, borderRadius: 1.5, bgcolor: TEAL_LIGHT, display: "flex", alignItems: "center", justifyContent: "center" }}>
//                                 {it.image_url
//                                   ? <Box component="img" src={it.image_url} alt={it.name} sx={{ width: "100%", height: "100%", objectFit: "cover", borderRadius: 1.5 }} />
//                                   : <CheckroomIcon sx={{ fontSize: 20, color: TEAL }} />}
//                               </Box>
//                               <Box minWidth={0}>
//                                 <Typography fontWeight={600} noWrap>{it.name}</Typography>
//                                 <Typography variant="caption" color="text.secondary">{it.unit} · ₹{p}</Typography>
//                               </Box>
//                             </Box>
//                             <Stack direction="row" spacing={1} alignItems="center" flexShrink={0}>
//                               {q > 0 && (
//                                 <Typography variant="body2" fontWeight={700} color={TEAL} sx={{ minWidth: 48, textAlign: "right" }}>
//                                   ₹{q * p}
//                                 </Typography>
//                               )}
//                               <IconButton size="small" onClick={() => setItemQty(it.name, -1)} disabled={!q}
//                                 sx={{ border: "1px solid #E2E8F0" }}><RemoveIcon fontSize="small" /></IconButton>
//                               <Typography sx={{ minWidth: 20, textAlign: "center", fontWeight: 700 }}>{q}</Typography>
//                               <IconButton size="small" onClick={() => setItemQty(it.name, 1)}
//                                 sx={{ color: "#fff", bgcolor: TEAL, "&:hover": { bgcolor: "#005961" } }}><AddIcon fontSize="small" /></IconButton>
//                             </Stack>
//                           </Paper>
//                         );
//                       })}
//                     </Stack>
//                   </AccordionDetails>
//                 </Accordion>
//               );
//             })}
//             {Object.keys(grouped).length === 0 && (
//               <Typography color="text.secondary">No items available for this service.</Typography>
//             )}
//           </Stack>

//           <Paper
//             elevation={6}
//             sx={{ position: "fixed", left: 0, right: 0, bottom: 0, zIndex: 10, borderTop: "1px solid #E2E8F0", bgcolor: "#fff", px: { xs: 2, sm: 4 }, py: 1.5 }}
//           >
//             <Container maxWidth="md" disableGutters>
//               <Stack direction="row" alignItems="center" justifyContent="space-between">
//                 <Box>
//                   <Typography variant="caption" color="text.secondary">
//                     {totalItemCount > 0 ? `${totalItemCount} item${totalItemCount > 1 ? "s" : ""} selected` : "No items selected"}
//                   </Typography>
//                   <Typography variant="h6" fontWeight={800} color={TEAL}>₹{subtotal}</Typography>
//                 </Box>
//                 <Button
//                   variant="contained" disabled={orderItems.length === 0} onClick={() => setStep(2)}
//                   sx={{ bgcolor: TEAL, textTransform: "none", px: 4, py: 1.2, borderRadius: 2 }}
//                 >
//                   Continue
//                 </Button>
//               </Stack>
//             </Container>
//           </Paper>
//         </Box>
//       )}

//       {/* Step 2: Pickup — prefilled from user's saved address, same pattern as MedicineDeliveryAddressScreen */}
//       {step === 2 && (
//         <Box>
//           <Typography variant="h6" fontWeight={700} mb={2}>Pickup details</Typography>

//           {userLoading ? (
//             <Box display="flex" justifyContent="center" py={4}><CircularProgress sx={{ color: TEAL }} /></Box>
//           ) : (
//             <Paper variant="outlined" sx={{ borderRadius: 3, overflow: "hidden" }}>
//               <Box sx={{ px: 3, py: 2, borderBottom: "1px solid #F1F5F9", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
//                 <Typography fontWeight={700}>Contact & Address</Typography>
//                 {isEditingAddress && (
//                   <IconButton size="small" onClick={cancelEditAddress}><CloseIcon fontSize="small" /></IconButton>
//                 )}
//               </Box>

//               {!isEditingAddress ? (
//                 <Box sx={{ p: 3 }}>
//                   <Typography fontWeight={700} mb={0.5}>{form.patient_name || "—"}</Typography>
//                   <Typography variant="body2" color="text.secondary" mb={2}>{form.phone || "—"}</Typography>
//                   <Box sx={{ bgcolor: "#F8FAFC", borderRadius: 2, p: 2, fontSize: 14, lineHeight: 1.8, color: "text.secondary" }}>
//                     {form.community_name && <><b>Community:</b> {form.community_name}<br /></>}
//                     {form.address_line1 && <><b>Address:</b> {form.address_line1}<br /></>}
//                     {form.address_line2 && <><b>Flat/House:</b> {form.address_line2}<br /></>}
//                     {form.pincode && <><b>Pincode:</b> {form.pincode}</>}
//                     {!form.address_line1 && "No address on file yet."}
//                   </Box>
//                   <Button startIcon={<EditIcon fontSize="small" />} onClick={openEditAddress}
//                     sx={{ mt: 2, textTransform: "none", color: TEAL, fontWeight: 700 }}>
//                     Edit pickup details
//                   </Button>
//                 </Box>
//               ) : (
//                 <Box sx={{ p: 3 }}>
//                   <Grid container spacing={2}>
//                     <Grid item xs={12} sm={6}>
//                       <TextField fullWidth label="Contact name" value={form.patient_name}
//                         onChange={(e) => handleAddressChange("patient_name", e.target.value)} />
//                     </Grid>
//                     <Grid item xs={12} sm={6}>
//                       <TextField fullWidth label="Phone" value={form.phone}
//                         onChange={(e) => handleAddressChange("phone", e.target.value.replace(/\D/g, "").slice(0, 10))} />
//                     </Grid>
//                     <Grid item xs={12} sm={6}>
//                       <TextField fullWidth label="Community / Society" value={form.community_name}
//                         onChange={(e) => handleAddressChange("community_name", e.target.value)} />
//                     </Grid>
//                     <Grid item xs={12} sm={6}>
//                       <TextField fullWidth label="Pincode" value={form.pincode}
//                         onChange={(e) => handleAddressChange("pincode", e.target.value)} />
//                     </Grid>
//                     <Grid item xs={12}>
//                       <TextField fullWidth label="Block / Building / Street" value={form.address_line1}
//                         onChange={(e) => handleAddressChange("address_line1", e.target.value)} />
//                     </Grid>
//                     <Grid item xs={12}>
//                       <TextField fullWidth label="Flat / House number" value={form.address_line2}
//                         onChange={(e) => handleAddressChange("address_line2", e.target.value)} />
//                     </Grid>
//                   </Grid>
//                   <Button variant="contained" onClick={saveAddress}
//                     sx={{ mt: 2, bgcolor: TEAL, textTransform: "none" }}>Save Address</Button>
//                 </Box>
//               )}
//             </Paper>
//           )}

//           <Button variant="contained" sx={{ mt: 3, bgcolor: TEAL, textTransform: "none" }}
//             disabled={!form.patient_name || !form.phone || !form.pickup_address}
//             onClick={() => setStep(3)}>Continue</Button>
//         </Box>
//       )}

//       {/* Step 3: Schedule */}
//       {step === 3 && (
//         <Box>
//           <Typography variant="h6" fontWeight={700} mb={2}>Schedule pickup & delivery</Typography>
//           <Grid container spacing={2}>
//             <Grid item xs={12} sm={6}><TextField sx={{width:"400px"}} type="date" label="Pickup date" InputLabelProps={{ shrink: true }}
//               value={form.pickup_date} inputProps={{ min: new Date().toISOString().split("T")[0] }}
//               onChange={(e) => setForm({ ...form, pickup_date: e.target.value })} /></Grid>
//             <Grid item xs={12} sm={6}><TextField select  sx={{width:"400px"}} label="Pickup time" value={form.pickup_time}
//               onChange={(e) => setForm({ ...form, pickup_time: e.target.value })}>
//               {TIME_SLOTS.map((t) => <MenuItem key={t} value={t}>{t}</MenuItem>)}</TextField></Grid>
//             <Grid item xs={12} sm={6}><TextField  sx={{width:"400px"}} type="date" label="Delivery date" InputLabelProps={{ shrink: true }}
//               value={form.delivery_date} inputProps={{ min: form.pickup_date || new Date().toISOString().split("T")[0] }}
//               onChange={(e) => setForm({ ...form, delivery_date: e.target.value })} /></Grid>
//             <Grid item xs={12} sm={6}><TextField select  sx={{width:"400px"}} label="Delivery time" value={form.delivery_time}
//               onChange={(e) => setForm({ ...form, delivery_time: e.target.value })}>
//               {TIME_SLOTS.map((t) => <MenuItem key={t} value={t}>{t}</MenuItem>)}</TextField></Grid>
//             <Grid item xs={12}><TextField  sx={{width:"820px"}} multiline rows={2} label="Notes (optional)" value={form.notes}
//               onChange={(e) => setForm({ ...form, notes: e.target.value })} /></Grid>
//           </Grid>
//            <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
//             <Button variant="contained" sx={{ mt: 2, bgcolor: TEAL, textTransform: "none" , width: "50%",}}
//                 disabled={!form.pickup_date || !form.delivery_date} onClick={() => setStep(4)}>
//              Continue
//             </Button>
//             </Box>
//         </Box>
//       )}


      

//       {/* Step 4: Pay — same visual language as MedicinePaymentScreen */}
//       {step === 4 && (
//         <LaundryPaymentStep
//           selService={selService}
//           orderItems={orderItems}
//           subtotal={subtotal}
//           walletBalance={walletBalance}
//           useWallet={useWallet}
//           setUseWallet={setUseWallet}
//           walletApplied={walletApplied}
//           total={total}
//           paymentMethod={paymentMethod}
//           setPaymentMethod={setPaymentMethod}
//           form={form}
//           loading={loading}
//           onBack={back}
//           onProceed={placeOrder}
//         />
//       )}
//     </Container>
//   );
// };

// // ============================================================ Pay step (styled like MedicinePaymentScreen)
// const LaundryPaymentStep = ({
//   selService, orderItems, subtotal, walletBalance, useWallet, setUseWallet,
//   walletApplied, total, paymentMethod, setPaymentMethod, form, loading, onBack, onProceed,
// }) => {
//   return (
//     <Box sx={{ bgcolor: "#F0F4F8", minHeight: "100vh", mx: { xs: -2, sm: -3 }, mt: -3, pb: 14, fontFamily: "'Inter', sans-serif" }}>
//       {/* Header */}
//       <Box sx={{
//         position: "sticky", top: 0, zIndex: 100,
//         background: "linear-gradient(135deg, #006D77 0%, #004E5A 100%)",
//         boxShadow: "0 2px 12px rgba(0,109,119,0.3)", px: 3,
//       }}>
//         <Box sx={{ maxWidth: 1100, mx: "auto", display: "flex", alignItems: "center", height: 64 }}>
//           <IconButton onClick={onBack} disabled={loading} sx={{ bgcolor: "rgba(255,255,255,0.15)", borderRadius: 2, mr: 2, color: "#fff" }}>
//             <ArrowBackIcon fontSize="small" />
//           </IconButton>
//           <Box>
//             <Typography sx={{ fontSize: 18, fontWeight: 700, color: "#fff" }}>Secure Checkout</Typography>
//             <Typography sx={{ fontSize: 12, color: "rgba(255,255,255,0.7)" }}>Complete your laundry booking</Typography>
//           </Box>
//           <Box sx={{ ml: "auto", display: "flex", alignItems: "center", gap: 0.75, bgcolor: "rgba(255,255,255,0.15)", borderRadius: 5, px: 1.5, py: 0.5 }}>
//             <Typography sx={{ fontSize: 12, color: "#4ADE80", fontWeight: 600 }}>🔒 256-bit SSL Encrypted</Typography>
//           </Box>
//         </Box>
//       </Box>

//       <Box sx={{ maxWidth: 1100, mx: "auto", px: { xs: 2, sm: 3 }, py: 3.5, display: "flex", gap: 3, alignItems: "flex-start", flexWrap: "wrap" }}>
//         {/* Left column */}
//         <Box sx={{ flex: "1 1 440px", minWidth: 300, display: "flex", flexDirection: "column", gap: 2 }}>

//           {/* Payment method */}
//           <Paper sx={{ borderRadius: 5, boxShadow: "0 2px 12px rgba(0,0,0,0.06)", overflow: "hidden" }}>
//             <Box sx={{ px: 3, py: 2.25, borderBottom: "1px solid #F1F5F9" }}>
//               <Typography sx={{ fontSize: 15, fontWeight: 700, color: "#0F172A" }}>Choose Payment Method</Typography>
//               <Typography sx={{ fontSize: 12, color: "#94A3B8", mt: 0.25 }}>Select how you'd like to pay</Typography>
//             </Box>

//             <Box
//               onClick={() => !loading && setPaymentMethod("online")}
//               sx={{
//                 m: 2, mb: 1, borderRadius: 3.5, cursor: "pointer", p: 2.25, position: "relative",
//                 border: paymentMethod === "online" ? `2px solid ${TEAL}` : "1.5px solid #E2E8F0",
//                 background: paymentMethod === "online" ? "linear-gradient(135deg,#f0fdf4,#e8faf4)" : "#FAFAFA",
//                 boxShadow: paymentMethod === "online" ? "0 4px 16px rgba(0,109,119,0.12)" : "none",
//               }}
//             >
//               {paymentMethod === "online" && (
//                 <Box sx={{ position: "absolute", top: -11, right: 14, background: "linear-gradient(135deg,#006D77,#00A896)", color: "#fff", fontSize: 10, fontWeight: 700, px: 1.25, py: 0.3, borderRadius: 5 }}>
//                   ⭐ RECOMMENDED
//                 </Box>
//               )}
//               <Stack direction="row" alignItems="center" justifyContent="space-between">
//                 <Stack direction="row" alignItems="center" spacing={1.75}>
//                   <Box sx={{ width: 46, height: 46, borderRadius: 3, background: "linear-gradient(135deg,#006D77,#00A896)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 22 }}>💳</Box>
//                   <Box>
//                     <Stack direction="row" alignItems="center" spacing={1}>
//                       <Typography sx={{ fontSize: 15, fontWeight: 700, color: "#0F172A" }}>Pay Online</Typography>
//                       <Box sx={{ bgcolor: "#D1FAE5", color: "#065F46", fontSize: 10, fontWeight: 700, px: 1, py: 0.15, borderRadius: 5 }}>INSTANT</Box>
//                     </Stack>
//                     <Typography sx={{ fontSize: 12, color: "#64748B", mt: 0.25 }}>UPI · Card · Net Banking · Wallets</Typography>
//                   </Box>
//                 </Stack>
//                 <Box sx={{ width: 22, height: 22, borderRadius: "50%", border: paymentMethod === "online" ? `6px solid ${TEAL}` : "2px solid #CBD5E1", bgcolor: "#fff", flexShrink: 0 }} />
//               </Stack>
//             </Box>

//             <Box
//               onClick={() => !loading && setPaymentMethod("cash")}
//               sx={{
//                 m: 2, mt: 0, borderRadius: 3.5, cursor: "pointer", p: 2.25,
//                 border: paymentMethod === "cash" ? `2px solid ${TEAL}` : "1.5px solid #E2E8F0",
//                 background: paymentMethod === "cash" ? "linear-gradient(135deg,#f0fdf4,#e8faf4)" : "#FAFAFA",
//                 boxShadow: paymentMethod === "cash" ? "0 4px 16px rgba(0,109,119,0.12)" : "none",
//               }}
//             >
//               <Stack direction="row" alignItems="center" justifyContent="space-between">
//                 <Stack direction="row" alignItems="center" spacing={1.75}>
//                   <Box sx={{ width: 46, height: 46, borderRadius: 3, background: "linear-gradient(135deg,#F59E0B,#D97706)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 22 }}>💵</Box>
//                   <Box>
//                     <Stack direction="row" alignItems="center" spacing={1}>
//                       <Typography sx={{ fontSize: 15, fontWeight: 700, color: "#0F172A" }}>Cash on Delivery</Typography>
//                       <Box sx={{ bgcolor: "#FEF3C7", color: "#92400E", fontSize: 10, fontWeight: 700, px: 1, py: 0.15, borderRadius: 5 }}>PAY LATER</Box>
//                     </Stack>
//                     <Typography sx={{ fontSize: 12, color: "#64748B", mt: 0.25 }}>Pay when your laundry is delivered</Typography>
//                   </Box>
//                 </Stack>
//                 <Box sx={{ width: 22, height: 22, borderRadius: "50%", border: paymentMethod === "cash" ? `6px solid ${TEAL}` : "2px solid #CBD5E1", bgcolor: "#fff", flexShrink: 0 }} />
//               </Stack>
//             </Box>
//           </Paper>

//           {/* Pickup address recap */}
//           <Paper sx={{ borderRadius: 5, boxShadow: "0 2px 12px rgba(0,0,0,0.06)", overflow: "hidden" }}>
//             <Stack direction="row" alignItems="center" spacing={1.25} sx={{ px: 3, py: 2.25, borderBottom: "1px solid #F1F5F9" }}>
//               <Box sx={{ width: 34, height: 34, borderRadius: 2.5, bgcolor: "#EFF6FF", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 16 }}>📍</Box>
//               <Box>
//                 <Typography sx={{ fontSize: 15, fontWeight: 700, color: "#0F172A" }}>Pickup Address</Typography>
//                 <Typography sx={{ fontSize: 12, color: "#94A3B8" }}>Where we'll collect your laundry</Typography>
//               </Box>
//             </Stack>
//             <Box sx={{ p: 3 }}>
//               <Stack direction="row" alignItems="center" spacing={1.5} mb={1.5}>
//                 <Box sx={{
//                   width: 40, height: 40, borderRadius: "50%",
//                   background: "linear-gradient(135deg,#006D77,#00A896)", color: "#fff",
//                   display: "flex", alignItems: "center", justifyContent: "center", fontSize: 16, fontWeight: 700, flexShrink: 0,
//                 }}>
//                   {(form.patient_name || "U")[0].toUpperCase()}
//                 </Box>
//                 <Box>
//                   <Typography sx={{ fontSize: 15, fontWeight: 700, color: "#0F172A" }}>{form.patient_name || "N/A"}</Typography>
//                   <Typography sx={{ fontSize: 12, color: TEAL, fontWeight: 600 }}>{form.phone || "N/A"}</Typography>
//                 </Box>
//               </Stack>
//               <Box sx={{ bgcolor: "#F8FAFC", borderRadius: 2.5, px: 1.75, py: 1.5, fontSize: 13, color: "#374151", lineHeight: 1.8 }}>
//                 {form.pickup_address || "No address provided"}
//               </Box>
//               {form.pickup_date && (
//                 <Stack direction="row" alignItems="center" spacing={1} mt={1.25} sx={{ bgcolor: "#EFF6FF", borderRadius: 2, px: 1.5, py: 1 }}>
//                   <Typography sx={{ fontSize: 12, color: "#3B82F6", fontWeight: 600 }}>
//                     ⏱ Pickup: {form.pickup_date} · {form.pickup_time || "—"} → Delivery: {form.delivery_date} · {form.delivery_time || "—"}
//                   </Typography>
//                 </Stack>
//               )}
//             </Box>
//           </Paper>
//         </Box>

//         {/* Right column — order summary */}
//         <Box sx={{ flex: "0 0 370px", minWidth: 300 }}>
//           <Paper sx={{ borderRadius: 5, boxShadow: "0 4px 20px rgba(0,0,0,0.08)", overflow: "hidden", position: "sticky", top: 80 }}>
//             <Box sx={{ background: "linear-gradient(135deg,#006D77 0%,#004E5A 100%)", px: 2.75, py: 2.25 }}>
//               <Typography sx={{ fontSize: 16, fontWeight: 700, color: "#fff" }}>Order Summary</Typography>
//               <Typography sx={{ fontSize: 12, color: "rgba(255,255,255,0.7)", mt: 0.25 }}>
//                 {selService?.name} · {orderItems.length} item type{orderItems.length !== 1 ? "s" : ""}
//               </Typography>
//             </Box>

//             <Box sx={{ px: 2.25, py: 2, maxHeight: "60vh", overflowY: "auto" }}>
//               {orderItems.map((it, idx) => (
//                 <Box key={idx} sx={{ border: "1px solid #E2E8F0", borderRadius: 3, overflow: "hidden", mb: 1.25 }}>
//                   <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ bgcolor: "#F8FAFC", px: 1.75, py: 1.25, borderBottom: "1px solid #E2E8F0" }}>
//                     <Box>
//                       <Typography sx={{ fontSize: 13, fontWeight: 700, color: "#0F172A" }}>{it.item}</Typography>
//                       <Typography sx={{ fontSize: 11, color: "#94A3B8", mt: 0.25 }}>{it.category} · Qty {it.quantity}</Typography>
//                     </Box>
//                     <Typography sx={{ fontSize: 14, fontWeight: 800, color: "#15803D" }}>₹{it.total}</Typography>
//                   </Stack>
//                 </Box>
//               ))}

//               <Box sx={{ bgcolor: "#F8FAFC", borderRadius: 3.5, px: 2, py: 1.75, mt: 1 }}>
//                 <Stack direction="row" justifyContent="space-between" mb={1}>
//                   <Typography sx={{ fontSize: 13, color: "#6B7280" }}>Subtotal</Typography>
//                   <Typography sx={{ fontSize: 13, fontWeight: 600, color: "#0F172A" }}>₹{subtotal}</Typography>
//                 </Stack>
//                 <Stack direction="row" justifyContent="space-between" mb={1}>
//                   <Typography sx={{ fontSize: 13, color: "#6B7280" }}>Delivery Charge</Typography>
//                   <Typography sx={{ fontSize: 13, fontWeight: 600, color: "#16A34A" }}>FREE</Typography>
//                 </Stack>

//                 {walletBalance > 0 && (
//                   <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ bgcolor: "#F0FDF4", borderRadius: 2, px: 1.25, py: 0.75, mb: 1 }}>
//                     <Stack direction="row" alignItems="center" spacing={1}>
//                       <input type="checkbox" checked={useWallet} onChange={(e) => setUseWallet(e.target.checked)} />
//                       <Typography sx={{ fontSize: 13, color: TEAL, fontWeight: 600 }}>Use wallet (₹{walletBalance.toFixed(0)})</Typography>
//                     </Stack>
//                     {useWallet && <Typography sx={{ fontSize: 13, color: "#16A34A", fontWeight: 700 }}>-₹{walletApplied}</Typography>}
//                   </Stack>
//                 )}

//                 <Divider sx={{ my: 1 }} />

//                 <Box sx={{
//                   display: "flex", justifyContent: "space-between", alignItems: "center",
//                   background: "linear-gradient(135deg,#006D77,#004E5A)", borderRadius: 3, px: 2, py: 1.75,
//                 }}>
//                   <Typography sx={{ fontSize: 11, color: "rgba(255,255,255,0.75)", fontWeight: 700, letterSpacing: 0.5, textTransform: "uppercase" }}>
//                     Total Payable
//                   </Typography>
//                   <Typography sx={{ fontSize: 24, fontWeight: 900, color: "#fff" }}>₹{total}</Typography>
//                 </Box>
//               </Box>
//             </Box>
//           </Paper>
//         </Box>
//       </Box>

//       {/* Sticky bottom proceed bar */}
//       <Box sx={{ position: "fixed", bottom: 0, left: 0, right: 0, zIndex: 100, bgcolor: "#fff", boxShadow: "0 -4px 20px rgba(0,0,0,0.10)", px: 2.5, py: 1.75 }}>
//         <Box sx={{ maxWidth: 1100, mx: "auto", display: "flex", alignItems: "center", gap: 2 }}>
//           <Box sx={{ flex: 1, minWidth: 0 }}>
//             <Typography sx={{ fontSize: 12, color: "#94A3B8", fontWeight: 600 }}>
//               {paymentMethod === "online" ? "💳 Pay Online" : "💵 Cash on Delivery"}
//             </Typography>
//             <Typography sx={{ fontSize: 20, fontWeight: 900, color: "#0F172A", mt: 0.25 }}>₹{total}</Typography>
//           </Box>
//           <Button
//             onClick={onProceed}
//             disabled={loading}
//             sx={{
//               background: loading ? "#94A3B8" : "linear-gradient(135deg,#006D77,#00A896)",
//               color: "#fff", borderRadius: 3.5, px: 4.5, py: 1.6, fontSize: 15, fontWeight: 700,
//               textTransform: "none", minWidth: 200,
//               boxShadow: loading ? "none" : "0 6px 20px rgba(0,109,119,0.35)",
//               "&:hover": { background: loading ? "#94A3B8" : "linear-gradient(135deg,#005961,#008f7f)" },
//             }}
//           >
//             {loading ? <CircularProgress size={20} sx={{ color: "#fff" }} /> : (paymentMethod === "online" ? `Pay ₹${total} Now` : "Confirm — Pay on Delivery")}
//           </Button>
//         </Box>
//       </Box>
//     </Box>
//   );
// };

// const Confirmation = ({ order, onDone }) => (
//   <Container maxWidth="sm" sx={{ py: 6, textAlign: "center" }}>
//     <CheckCircleIcon sx={{ fontSize: 72, color: "#2e7d32" }} />
//     <Typography variant="h5" fontWeight={800} mt={1}>Order Placed!</Typography>
//     <Typography color="text.secondary" mb={3}>We'll pick up your laundry as scheduled.</Typography>
//     <Paper variant="outlined" sx={{ p: 3, borderRadius: 3, textAlign: "left" }}>
//       <Typography variant="caption" color="text.secondary">Order Code</Typography>
//       <Typography variant="h6" fontWeight={800} color={TEAL} fontFamily="monospace" mb={2}>{order.order_code}</Typography>
//       <Row label="Service" value={order.service_type} />
//       <Row label="Pickup" value={`${order.pickup_date} · ${order.pickup_time}`} />
//       <Row label="Delivery" value={`${order.delivery_date} · ${order.delivery_time}`} />
//       <Row label="Total" value={`₹${order.total_amount}`} bold />
//       <Row label="Payment" value={order.payment_status === "paid" ? "Paid" : "Pay on delivery"} />
//     </Paper>
//     <Button variant="contained" sx={{ mt: 3, bgcolor: TEAL, textTransform: "none" }} onClick={onDone}>Done</Button>
//   </Container>
// );

// const Row = ({ label, value, bold }) => (
//   <Box display="flex" justifyContent="space-between" py={0.5}>
//     <Typography color="text.secondary">{label}</Typography>
//     <Typography fontWeight={bold ? 800 : 600}>{value}</Typography>
//   </Box>
// );

// export default LaundryBooking;






import { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import {
  Box, Container, Typography, Stepper, Step, StepLabel, Grid, Card, CardActionArea,
  Button, TextField, MenuItem, Divider, Alert, CircularProgress, Paper, Stack, IconButton,
  Accordion, AccordionSummary, AccordionDetails, Chip,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CheckroomIcon from "@mui/icons-material/Checkroom";
import EditIcon from "@mui/icons-material/Edit";
import CloseIcon from "@mui/icons-material/Close";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import { fetchUserFromRedis } from "../HomePage/AuthonticationScreens/Register";

const API = process.env.REACT_APP_API_LAUNDRY_URL;
const authHeaders = () => ({ headers: { Authorization: `Bearer ${sessionStorage.getItem("token")}` } });
const TEAL = "#006D77";
const TEAL_LIGHT = "#E0F7F8";
const STEPS = ["Service", "Items", "Pickup", "Schedule", "Pay"];
const TIME_SLOTS = ["7-9 AM", "9-11 AM", "11 AM-1 PM", "2-4 PM", "4-6 PM"];
const DELIVERY_CHARGE = 0;

const SERVICE_CARD_HEIGHT = 240;
const SERVICE_IMAGE_HEIGHT = 140;

const LaundryBooking = () => {
  const navigate = useNavigate();
  const community = sessionStorage.getItem("community") || "";

  const [step, setStep] = useState(0);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [confirmed, setConfirmed] = useState(null);

  const [services, setServices] = useState([]);
  const [selService, setSelService] = useState(null);
  const [items, setItems] = useState([]);
  const [prices, setPrices] = useState([]);
  const [qty, setQty] = useState({});
  const [expandedCat, setExpandedCat] = useState(null);

  // ─── Pickup / address state ────────────────────────────────────────────────
  const [form, setForm] = useState({
    patient_name: "", phone: "",
    community_name: "", address_line1: "", address_line2: "", pincode: "",
    pickup_address: "",
    pickup_date: "", pickup_time: "", delivery_date: "", delivery_time: "", notes: "",
  });
  const [isEditingAddress, setIsEditingAddress] = useState(false);
  const [originalFormData, setOriginalFormData] = useState(null);
  const [userLoading, setUserLoading] = useState(true);

  const [walletBalance, setWalletBalance] = useState(0);
  const [useWallet, setUseWallet] = useState(false);
  const [paymentMethod, setPaymentMethod] = useState("cash");
  const [razorpayLoaded, setRazorpayLoaded] = useState(false);

  useEffect(() => {
    axios.get(`${API}/booking/services`, { ...authHeaders(), params: { community } })
      .then((r) => setServices(r.data || [])).catch(() => {});

    axios.get(`${process.env.REACT_APP_REFERRAL_API}/referral/summary`, authHeaders())
      .then((r) => setWalletBalance(r.data?.wallet_balance || 0)).catch(() => {});

    if (window.Razorpay) setRazorpayLoaded(true);
    else {
      const s = document.createElement("script");
      s.src = process.env.REACT_APP_RAZORPAY_SCRIPT; s.async = true;
      s.onload = () => setRazorpayLoaded(true);
      document.body.appendChild(s);
    }
    /* eslint-disable-next-line */
  }, []);

  useEffect(() => {
    const loadUser = async () => {
      const userId = sessionStorage.getItem("userId");
      const token = sessionStorage.getItem("token");
      if (!userId || !token) { setUserLoading(false); return; }
      try {
        const userData = await fetchUserFromRedis(userId, token);
        if (userData) {
          const addr = userData.address || {};
          const rawPhone = (addr.phone || userData.phone || "").replace(/\D/g, "");
          const phone = rawPhone.length === 12 && rawPhone.startsWith("91") ? rawPhone.slice(2) : rawPhone;
          const joined = [addr.address_line1, addr.address_line2, addr.community_name]
            .filter(Boolean).join(", ");
          setForm((prev) => ({
            ...prev,
            patient_name: addr.full_name || userData.name || "",
            phone,
            community_name: addr.community_name || "",
            address_line1: addr.address_line1 || "",
            address_line2: addr.address_line2 || "",
            pincode: addr.pincode || "",
            pickup_address: joined,
          }));
          if (!addr.address_line1) setIsEditingAddress(true);
        } else {
          setIsEditingAddress(true);
        }
      } catch {
        setIsEditingAddress(true);
      } finally {
        setUserLoading(false);
      }
    };
    loadUser();
  }, []);

  const pickService = async (svc) => {
    setSelService(svc); setError("");
    try {
      const [itRes, prRes] = await Promise.all([
        axios.get(`${API}/booking/items`, { ...authHeaders(), params: { community } }),
        axios.get(`${API}/booking/prices`, { ...authHeaders(), params: { community, service: svc.name } }),
      ]);
      setItems(itRes.data || []); setPrices(prRes.data || []);
      const firstCat = (itRes.data || [])[0]?.category || null;
      setExpandedCat(firstCat);
      setStep(1);
    } catch { setError("Could not load items."); }
  };

  const priceOf = (n) => prices.find((p) => p.item === n)?.price || 0;
  const setItemQty = (name, delta) => setQty((prev) => {
    const next = Math.max(0, (prev[name] || 0) + delta);
    const c = { ...prev }; if (next === 0) delete c[name]; else c[name] = next; return c;
  });

  const orderItems = Object.entries(qty).map(([name, q]) => {
    const it = items.find((x) => x.name === name); const price = priceOf(name);
    return { category: it?.category, item: name, quantity: q, price, total: q * price };
  });
  const subtotal = orderItems.reduce((s, i) => s + i.total, 0);
  const totalItemCount = orderItems.reduce((s, i) => s + i.quantity, 0);
  const walletApplied = useWallet ? Math.min(walletBalance, subtotal + DELIVERY_CHARGE) : 0;
  const total = Math.max(0, subtotal + DELIVERY_CHARGE - walletApplied);

  const handleAddressChange = (field, value) => setForm((prev) => ({ ...prev, [field]: value }));
  const openEditAddress = () => { setOriginalFormData({ ...form }); setIsEditingAddress(true); };
  const cancelEditAddress = () => {
    if (originalFormData) setForm(originalFormData);
    setIsEditingAddress(false);
  };
  const saveAddress = () => {
    const joined = [form.address_line1, form.address_line2, form.community_name]
      .filter(Boolean).join(", ");
    setForm((prev) => ({ ...prev, pickup_address: joined }));
    setIsEditingAddress(false);
  };

  const buildPayload = (extra = {}) => ({
    community, service_type: selService.name, items: orderItems,
    pickup_address: form.pickup_address, pickup_date: form.pickup_date, pickup_time: form.pickup_time,
    delivery_date: form.delivery_date, delivery_time: form.delivery_time,
    subtotal, delivery_charge: DELIVERY_CHARGE, discount: 0, wallet_amount: walletApplied, tax: 0,
    patient_name: form.patient_name, phone: form.phone, notes: form.notes, ...extra,
  });

  const placeOrder = async () => {
    const miss = [];
    if (!form.patient_name) miss.push("Name");
    if (!form.phone) miss.push("Phone");
    if (!form.pickup_address) miss.push("Pickup address");
    if (!form.pickup_date) miss.push("Pickup date");
    if (!form.delivery_date) miss.push("Delivery date");
    if (orderItems.length === 0) miss.push("At least one item");
    if (miss.length) { setError(`Please provide: ${miss.join(", ")}`); return; }
    setError(""); setLoading(true);

    if (paymentMethod === "cash" || (useWallet && total === 0)) {
      try {
        const res = await axios.post(`${API}/booking/orders`,
          buildPayload({ payment_method: useWallet && total === 0 ? "wallet" : "cash" }), authHeaders());
        setConfirmed(res.data);
      } catch { setError("Could not place order. Please try again."); }
      finally { setLoading(false); }
      return;
    }

    if (!razorpayLoaded || !window.Razorpay) { setError("Payment gateway loading, try again."); setLoading(false); return; }
    try {
      const orderRes = await axios.post(`${API}/booking/orders`, buildPayload({ payment_method: "online" }), authHeaders());
      const created = orderRes.data;
      const rzpOrder = await axios.post(process.env.REACT_APP_CREATE_RAZORPAY_ORDER, {
        amount: total, currency: "INR", receipt: created.order_code,
        service_type: "laundry", customer_name: form.patient_name, contact: form.phone,
      });
      setLoading(false);
      const rzp = new window.Razorpay({
        key: process.env.REACT_APP_RAZORPAY_KEY, currency: "INR",
        name: "Ayuja Laundry", description: selService.name, order_id: rzpOrder.data.id,
        prefill: { name: form.patient_name, contact: form.phone }, theme: { color: TEAL },
        handler: async (resp) => {
          setLoading(true);
          try {
            const verify = await axios.post(process.env.REACT_APP_PROCESS_PAYEMENT, {
              razorpay_payment_id: resp.razorpay_payment_id,
              razorpay_order_id: resp.razorpay_order_id,
              razorpay_signature: resp.razorpay_signature,
            });
            if (!verify.data?.verified) throw new Error("verify failed");
            const conf = await axios.post(`${API}/booking/orders/confirm-payment`, {
              order_id: created.id,
              razorpay_order_id: resp.razorpay_order_id,
              razorpay_payment_id: resp.razorpay_payment_id,
            }, authHeaders());
            setConfirmed(conf.data);
          } catch { setError("Payment received but confirmation failed. Contact support."); }
          finally { setLoading(false); }
        },
        modal: { ondismiss: () => { setLoading(false); setError("Payment cancelled."); } },
      });
      rzp.on("payment.failed", (r) => { setLoading(false); setError(`Payment failed: ${r.error?.description || ""}`); });
      rzp.open();
    } catch { setError("Could not start payment."); setLoading(false); }
  };

  const back = () => { setError(""); setStep((s) => Math.max(0, s - 1)); };
  if (confirmed) return <Confirmation order={confirmed} onDone={() => navigate("/laundry-service")} />;

  const grouped = items.reduce((acc, it) => { (acc[it.category] = acc[it.category] || []).push(it); return acc; }, {});
  const categoryCount = (cat) => (grouped[cat] || []).reduce((s, it) => s + (qty[it.name] || 0), 0);
  const categorySubtotal = (cat) => (grouped[cat] || []).reduce((s, it) => s + (qty[it.name] || 0) * priceOf(it.name), 0);

  return (
    <Container maxWidth="lg" sx={{ py: { xs: 3, sm: 5 }, px: { xs: 2, sm: 3 }, pb: (step === 1 || step === 4) ? 14 : 5 }}>



      <Button startIcon={<ArrowBackIcon />} onClick={step > 0 ? back : () => navigate(-1)}
        sx={{ mb: 2, textTransform: "none", color: TEAL, fontWeight: 600 }}>Back</Button>

      <Typography variant="h4" fontWeight={800} color={TEAL} gutterBottom
        sx={{ fontSize: { xs: "1.7rem", sm: "2.125rem" } }}>Book Laundry Service</Typography>
      <Typography color="text.secondary" mb={4}>Pickup · Wash · Delivered to your door</Typography>

      <Stepper activeStep={step} alternativeLabel sx={{ mb: 4, "& .MuiStepLabel-label": { fontSize: { xs: 11, sm: 14 } } }}>
        {STEPS.map((l) => <Step key={l}><StepLabel>{l}</StepLabel></Step>)}
      </Stepper>

      {error && <Alert severity="error" sx={{ mb: 3 }}>{error}</Alert>}


        {/* Step 0: Service */}
        {step === 0 && (
        <Box sx={{display: "grid",gridTemplateColumns: { xs: "1fr", sm: "repeat(2, minmax(0, 1fr))" }, gridAutoRows: "1fr",gap: 2.5,}}>
            {services.map((svc) => (
            <Card
                key={svc.id}
                variant="outlined"
                sx={{borderRadius: 3,overflow: "hidden",width: "100%",height: "100%",display: "flex",flexDirection: "column",transition: "all .15s ease",
                "&:hover": { borderColor: TEAL, boxShadow: 4, transform: "translateY(-2px)" },
                }}
            >
                <CardActionArea
                onClick={() => pickService(svc)}
                sx={{height: "100%",display: "flex",flexDirection: "column",alignItems: "stretch",justifyContent: "flex-start",}}
                >
                <Box sx={{ height: SERVICE_IMAGE_HEIGHT, flexShrink: 0, bgcolor: TEAL_LIGHT }}>
                    {svc.image_url ? (
                    <Box component="img" src={svc.image_url} alt={svc.name}
                        sx={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }}
                    />
                    ) : (
                    <Box sx={{ height: "100%", display: "flex", alignItems: "center", justifyContent: "center" }}>
                        <CheckroomIcon sx={{ fontSize: 48, color: TEAL, opacity: 0.6 }} />
                    </Box>
                    )}
                </Box>

                <Box p={2} sx={{ flex: 1, width: "100%", minWidth: 0 }}>
                    <Typography fontWeight={700} sx={{ wordBreak: "break-word" }}>
                    {svc.name}
                    </Typography>
                    <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5, whiteSpace: "normal", wordBreak: "break-word" }}  >
                    {svc.description}
                    </Typography>
                </Box>
                </CardActionArea>
            </Card>
            ))}

            {services.length === 0 && (
            <Typography color="text.secondary" sx={{ gridColumn: "1 / -1" }}>
                No services available.
            </Typography>
            )}
        </Box>
        )}

      {/* Step 1: Items */}
      {step === 1 && (
        <Box>
          <Typography variant="h6" fontWeight={700} mb={2}>{selService?.name} — choose items</Typography>

          <Stack spacing={1.5}>
            {Object.entries(grouped).map(([cat, list]) => {
              const isOpen = expandedCat === cat;
              const count = categoryCount(cat);
              return (
                <Accordion
                  key={cat}
                  expanded={isOpen}
                  onChange={() => setExpandedCat(isOpen ? null : cat)}
                  disableGutters
                  variant="outlined"
                  sx={{ borderRadius: "12px !important", overflow: "hidden", "&:before": { display: "none" }, borderColor: isOpen ? TEAL : "#E2E8F0" }}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon sx={{ color: isOpen ? TEAL : "inherit" }} />}
                    sx={{ bgcolor: isOpen ? TEAL_LIGHT : "#FAFAFA", px: 2.5, "& .MuiAccordionSummary-content": { alignItems: "center", gap: 1.5 } }}
                  >
                    <Typography fontWeight={700} color={isOpen ? TEAL : "text.primary"}>{cat}</Typography>
                    <Chip label={`${list.length} items`} size="small" variant="outlined" sx={{ borderColor: "#CBD5E1" }} />
                    {count > 0 && (
                      <Chip
                        label={`${count} selected · ₹${categorySubtotal(cat)}`}
                        size="small"
                        sx={{ bgcolor: TEAL, color: "#fff", fontWeight: 700, ml: "auto !important" }}
                      />
                    )}
                  </AccordionSummary>
                  <AccordionDetails sx={{ p: 2, bgcolor: "#fff" }}>
                    <Stack spacing={1}>
                      {list.map((it) => {
                        const p = priceOf(it.name);
                        const q = qty[it.name] || 0;
                        return (
                          <Paper
                            key={it.id}
                            variant="outlined"
                            sx={{
                              p: 1.5, borderRadius: 2, display: "flex", alignItems: "center", justifyContent: "space-between",
                              borderColor: q > 0 ? TEAL : "#E2E8F0", bgcolor: q > 0 ? "#F5FCFC" : "#fff",
                            }}
                          >
                            <Box display="flex" alignItems="center" gap={1.5} minWidth={0}>
                              <Box sx={{ width: 40, height: 40, flexShrink: 0, borderRadius: 1.5, bgcolor: TEAL_LIGHT, display: "flex", alignItems: "center", justifyContent: "center" }}>
                                {it.image_url
                                  ? <Box component="img" src={it.image_url} alt={it.name} sx={{ width: "100%", height: "100%", objectFit: "cover", borderRadius: 1.5 }} />
                                  : <CheckroomIcon sx={{ fontSize: 20, color: TEAL }} />}
                              </Box>
                              <Box minWidth={0}>
                                <Typography fontWeight={600} noWrap>{it.name}</Typography>
                                <Typography variant="caption" color="text.secondary">{it.unit} · ₹{p}</Typography>
                              </Box>
                            </Box>
                            <Stack direction="row" spacing={1} alignItems="center" flexShrink={0}>
                              {q > 0 && (
                                <Typography variant="body2" fontWeight={700} color={TEAL} sx={{ minWidth: 48, textAlign: "right" }}>
                                  ₹{q * p}
                                </Typography>
                              )}
                              <IconButton size="small" onClick={() => setItemQty(it.name, -1)} disabled={!q}
                                sx={{ border: "1px solid #E2E8F0" }}><RemoveIcon fontSize="small" /></IconButton>
                              <Typography sx={{ minWidth: 20, textAlign: "center", fontWeight: 700 }}>{q}</Typography>
                              <IconButton size="small" onClick={() => setItemQty(it.name, 1)}
                                sx={{ color: "#fff", bgcolor: TEAL, "&:hover": { bgcolor: "#005961" } }}><AddIcon fontSize="small" /></IconButton>
                            </Stack>
                          </Paper>
                        );
                      })}
                    </Stack>
                  </AccordionDetails>
                </Accordion>
              );
            })}
            {Object.keys(grouped).length === 0 && (
              <Typography color="text.secondary">No items available for this service.</Typography>
            )}
          </Stack>

          <Paper
            elevation={6}
            sx={{ position: "fixed", left: 0, right: 0, bottom: 0, zIndex: 10, borderTop: "1px solid #E2E8F0", bgcolor: "#fff", px: { xs: 2, sm: 4 }, py: 1.5 }}
          >
            <Container maxWidth="md" disableGutters>
              <Stack direction="row" alignItems="center" justifyContent="space-between">
                <Box>
                  <Typography variant="caption" color="text.secondary">
                    {totalItemCount > 0 ? `${totalItemCount} item${totalItemCount > 1 ? "s" : ""} selected` : "No items selected"}
                  </Typography>
                  <Typography variant="h6" fontWeight={800} color={TEAL}>₹{subtotal}</Typography>
                </Box>
                <Button
                  variant="contained" disabled={orderItems.length === 0} onClick={() => setStep(2)}
                  sx={{ bgcolor: TEAL, textTransform: "none", px: 4, py: 1.2, borderRadius: 2 }}
                >
                  Continue
                </Button>
              </Stack>
            </Container>
          </Paper>
        </Box>
      )}

      {/* Step 2: Pickup */}
      {step === 2 && (
        <Box>
          <Typography variant="h6" fontWeight={700} mb={2}>Pickup details</Typography>

          {userLoading ? (
            <Box display="flex" justifyContent="center" py={4}><CircularProgress sx={{ color: TEAL }} /></Box>
          ) : (
            <Paper variant="outlined" sx={{ borderRadius: 3, overflow: "hidden" }}>
              <Box sx={{ px: 3, py: 2, borderBottom: "1px solid #F1F5F9", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <Typography fontWeight={700}>Contact & Address</Typography>
                {isEditingAddress && (
                  <IconButton size="small" onClick={cancelEditAddress}><CloseIcon fontSize="small" /></IconButton>
                )}
              </Box>

              {!isEditingAddress ? (
                <Box sx={{ p: 3 }}>
                  <Typography fontWeight={700} mb={0.5}>{form.patient_name || "—"}</Typography>
                  <Typography variant="body2" color="text.secondary" mb={2}>{form.phone || "—"}</Typography>
                  <Box sx={{ bgcolor: "#F8FAFC", borderRadius: 2, p: 2, fontSize: 14, lineHeight: 1.8, color: "text.secondary" }}>
                    {form.community_name && <><b>Community:</b> {form.community_name}<br /></>}
                    {form.address_line1 && <><b>Address:</b> {form.address_line1}<br /></>}
                    {form.address_line2 && <><b>Flat/House:</b> {form.address_line2}<br /></>}
                    {form.pincode && <><b>Pincode:</b> {form.pincode}</>}
                    {!form.address_line1 && "No address on file yet."}
                  </Box>
                  <Button startIcon={<EditIcon fontSize="small" />} onClick={openEditAddress}
                    sx={{ mt: 2, textTransform: "none", color: TEAL, fontWeight: 700 }}>
                    Edit pickup details
                  </Button>
                </Box>
              ) : (
                <Box sx={{ p: 3 }}>
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={6}>
                      <TextField fullWidth label="Contact name" value={form.patient_name}
                        onChange={(e) => handleAddressChange("patient_name", e.target.value)} />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField fullWidth label="Phone" value={form.phone}
                        onChange={(e) => handleAddressChange("phone", e.target.value.replace(/\D/g, "").slice(0, 10))} />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField fullWidth label="Community / Society" value={form.community_name}
                        onChange={(e) => handleAddressChange("community_name", e.target.value)} />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField fullWidth label="Pincode" value={form.pincode}
                        onChange={(e) => handleAddressChange("pincode", e.target.value)} />
                    </Grid>
                    <Grid item xs={12}>
                      <TextField fullWidth label="Block / Building / Street" value={form.address_line1}
                        onChange={(e) => handleAddressChange("address_line1", e.target.value)} />
                    </Grid>
                    <Grid item xs={12}>
                      <TextField fullWidth label="Flat / House number" value={form.address_line2}
                        onChange={(e) => handleAddressChange("address_line2", e.target.value)} />
                    </Grid>
                  </Grid>
                  <Button variant="contained" onClick={saveAddress}
                    sx={{ mt: 2, bgcolor: TEAL, textTransform: "none" }}>Save Address</Button>
                </Box>
              )}
            </Paper>
          )}

          <Box sx={{ display: "flex", justifyContent: "center", mt: 3 }}>
            <Button variant="contained" sx={{ bgcolor: TEAL, textTransform: "none", width: { xs: "100%", sm: "50%" } }}
              disabled={!form.patient_name || !form.phone || !form.pickup_address}
              onClick={() => setStep(3)}>Continue</Button>
          </Box>
        </Box>
      )}

      {/* Step 3: Schedule */}
      {step === 3 && (
        <Box>
          <Typography variant="h6" fontWeight={700} mb={2}>Schedule pickup & delivery</Typography>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <TextField sx={{width:"400px"}} type="date" label="Pickup date" InputLabelProps={{ shrink: true }}
                value={form.pickup_date} inputProps={{ min: new Date().toISOString().split("T")[0] }}
                onChange={(e) => setForm({ ...form, pickup_date: e.target.value })} />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField select sx={{width:"400px"}} label="Pickup time" value={form.pickup_time}
                onChange={(e) => setForm({ ...form, pickup_time: e.target.value })}>
                {TIME_SLOTS.map((t) => <MenuItem key={t} value={t}>{t}</MenuItem>)}
              </TextField>
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField sx={{width:"400px"}} type="date" label="Delivery date" InputLabelProps={{ shrink: true }}
                value={form.delivery_date} inputProps={{ min: form.pickup_date || new Date().toISOString().split("T")[0] }}
                onChange={(e) => setForm({ ...form, delivery_date: e.target.value })} />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField select sx={{width:"400px"}} label="Delivery time" value={form.delivery_time}
                onChange={(e) => setForm({ ...form, delivery_time: e.target.value })}>
                {TIME_SLOTS.map((t) => <MenuItem key={t} value={t}>{t}</MenuItem>)}
              </TextField>
            </Grid>
            <Grid item xs={12}>
              <TextField sx={{width:"820px"}} multiline rows={2} label="Notes (optional)" value={form.notes}
                onChange={(e) => setForm({ ...form, notes: e.target.value })} />
            </Grid>
          </Grid>
          <Box sx={{ display: "flex", mt: 3 }}>
            <Button variant="contained" sx={{ bgcolor: TEAL, textTransform: "none", width: { xs: "100%", sm: "50%" } }}
              disabled={!form.pickup_date || !form.delivery_date} onClick={() => setStep(4)}>
              Continue
            </Button>
          </Box>
        </Box>
      )}

      {/* Step 4: Pay — same shell (Back/Title/Stepper) as every other step, styled to match */}
      {step === 4 && (
        <Box>
          <Typography variant="h6" fontWeight={700} mb={2}>Review & Pay</Typography>

          {/* Payment method */}
          <Paper variant="outlined" sx={{ borderRadius: 3, overflow: "hidden", mb: 2.5 }}>
            <Box sx={{ px: 3, py: 2, borderBottom: "1px solid #F1F5F9" }}>
              <Typography fontWeight={700}>Choose Payment Method</Typography>
              <Typography variant="caption" color="text.secondary">Select how you'd like to pay</Typography>
            </Box>
            <Box sx={{ p: 2 }}>
              <Paper
                variant="outlined"
                onClick={() => !loading && setPaymentMethod("online")}
                sx={{
                  borderRadius: 2.5, cursor: "pointer", p: 2, mb: 1.5, position: "relative",
                  borderColor: paymentMethod === "online" ? TEAL : "#E2E8F0",
                  borderWidth: paymentMethod === "online" ? 2 : 1,
                  bgcolor: paymentMethod === "online" ? TEAL_LIGHT : "#FAFAFA",
                }}
              >
                {paymentMethod === "online" && (
                  <Chip label="⭐ RECOMMENDED" size="small"
                    sx={{ position: "absolute", top: -12, right: 14, bgcolor: TEAL, color: "#fff", fontWeight: 700, fontSize: 10 }} />
                )}
                <Stack direction="row" alignItems="center" justifyContent="space-between">
                  <Stack direction="row" alignItems="center" spacing={1.75}>
                    <Box sx={{ width: 44, height: 44, borderRadius: 2, bgcolor: TEAL, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 20 }}>💳</Box>
                    <Box>
                      <Typography fontWeight={700}>Pay Online</Typography>
                      <Typography variant="caption" color="text.secondary">UPI · Card · Net Banking · Wallets</Typography>
                    </Box>
                  </Stack>
                  <Box sx={{ width: 20, height: 20, borderRadius: "50%", border: paymentMethod === "online" ? `6px solid ${TEAL}` : "2px solid #CBD5E1", bgcolor: "#fff" }} />
                </Stack>
              </Paper>

              <Paper
                variant="outlined"
                onClick={() => !loading && setPaymentMethod("cash")}
                sx={{
                  borderRadius: 2.5, cursor: "pointer", p: 2,
                  borderColor: paymentMethod === "cash" ? TEAL : "#E2E8F0",
                  borderWidth: paymentMethod === "cash" ? 2 : 1,
                  bgcolor: paymentMethod === "cash" ? TEAL_LIGHT : "#FAFAFA",
                }}
              >
                <Stack direction="row" alignItems="center" justifyContent="space-between">
                  <Stack direction="row" alignItems="center" spacing={1.75}>
                    <Box sx={{ width: 44, height: 44, borderRadius: 2, bgcolor: "#D97706", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 20 }}>💵</Box>
                    <Box>
                      <Typography fontWeight={700}>Cash on Delivery</Typography>
                      <Typography variant="caption" color="text.secondary">Pay when your laundry is delivered</Typography>
                    </Box>
                  </Stack>
                  <Box sx={{ width: 20, height: 20, borderRadius: "50%", border: paymentMethod === "cash" ? `6px solid ${TEAL}` : "2px solid #CBD5E1", bgcolor: "#fff" }} />
                </Stack>
              </Paper>
            </Box>
          </Paper>

          {/* Pickup address recap */}
          <Paper variant="outlined" sx={{ borderRadius: 3, overflow: "hidden", mb: 2.5 }}>
            <Stack direction="row" alignItems="center" spacing={1.25} sx={{ px: 3, py: 2, borderBottom: "1px solid #F1F5F9" }}>
              <LocationOnIcon sx={{ color: TEAL }} fontSize="small" />
              <Typography fontWeight={700}>Pickup Address</Typography>
            </Stack>
            <Box sx={{ p: 3 }}>
              <Typography fontWeight={700}>{form.patient_name || "N/A"}</Typography>
              <Typography variant="body2" color={TEAL} fontWeight={600} mb={1.5}>{form.phone || "N/A"}</Typography>
              <Box sx={{ bgcolor: "#F8FAFC", borderRadius: 2, px: 2, py: 1.5, fontSize: 14, color: "text.secondary" }}>
                {form.pickup_address || "No address provided"}
              </Box>
              {form.pickup_date && (
                <Chip
                  size="small"
                  label={`Pickup: ${form.pickup_date} · ${form.pickup_time || "—"}  →  Delivery: ${form.delivery_date} · ${form.delivery_time || "—"}`}
                  sx={{ mt: 1.5, bgcolor: "#EFF6FF", color: "#3B82F6", fontWeight: 600,pointerEvents:"none" }}
                />
              )}
            </Box>
          </Paper>

          {/* Order summary */}
          <Paper variant="outlined" sx={{ borderRadius: 3, overflow: "hidden",pb: 10 }}>
            <Box sx={{ px: 3, py: 2, borderBottom: "1px solid #F1F5F9" }}>
              <Typography fontWeight={700}>Order Summary</Typography>
              <Typography variant="caption" color="text.secondary">
                {selService?.name} · {orderItems.length} item type{orderItems.length !== 1 ? "s" : ""}
              </Typography>
            </Box>

            <Box sx={{ pt: 2, px: 2,}}>
              {orderItems.map((it, idx) => (
                <Stack key={idx} direction="row" justifyContent="space-between" alignItems="center"
                  sx={{ bgcolor: "#F8FAFC", borderRadius: 2, px: 2, py: 1.25, mb: 1 }}>
                  <Box>
                    <Typography fontWeight={600} variant="body2">{it.item}</Typography>
                    <Typography variant="caption" color="text.secondary">{it.category} · Qty {it.quantity}</Typography>
                  </Box>
                  <Typography fontWeight={700} color={TEAL}>₹{it.total}</Typography>
                </Stack>
              ))}

              <Divider sx={{ my: 1.5 }} />
              <Stack direction="row" justifyContent="space-between" mb={1}>
                <Typography variant="body2" color="text.secondary">Subtotal</Typography>
                <Typography variant="body2" fontWeight={600}>₹{subtotal}</Typography>
              </Stack>
              <Stack direction="row" justifyContent="space-between" mb={1}>
                <Typography variant="body2" color="text.secondary">Delivery Charge</Typography>
                <Typography variant="body2" fontWeight={600} color="success.main">FREE</Typography>
              </Stack>

              {walletBalance > 0 && (
                <Stack direction="row" alignItems="center" justifyContent="space-between"
                  sx={{ bgcolor: TEAL_LIGHT, borderRadius: 2, px: 1.5, py: 1, mb: 1 }}>
                  <Stack direction="row" alignItems="center" spacing={1}>
                    <input type="checkbox" checked={useWallet} onChange={(e) => setUseWallet(e.target.checked)} />
                    <Typography variant="body2" color={TEAL} fontWeight={600}>Use wallet (₹{walletBalance.toFixed(0)})</Typography>
                  </Stack>
                  {useWallet && <Typography variant="body2" color="success.main" fontWeight={700}>-₹{walletApplied}</Typography>}
                </Stack>
              )}

              <Divider sx={{ my: 1.5 }} />
              <Stack direction="row" justifyContent="space-between" alignItems="center"
                sx={{ bgcolor: TEAL, borderRadius: 2, px: 2.5, py: 2 }}>
                <Typography sx={{ color: "rgba(255,255,255,0.8)", fontSize: 12, fontWeight: 700, letterSpacing: 0.5, textTransform: "uppercase" }}>
                  Total Payable
                </Typography>
                <Typography sx={{ color: "#fff", fontSize: 24, fontWeight: 800 }}>₹{total}</Typography>
              </Stack>
            </Box>
          </Paper>

          {/* Pinned bottom bar — same pattern as Step 1 */}
          <Paper
            elevation={6}
            sx={{ position: "fixed", left: 0, right: 0, bottom: 0, zIndex: 10, borderTop: "1px solid #E2E8F0", bgcolor: "#fff", px: { xs: 2, sm: 4 }, py: 1.5 }}
          >
            <Container maxWidth="md" disableGutters>
              <Stack direction="row" alignItems="center" justifyContent="space-between">
                <Box>
                  <Typography variant="caption" color="text.secondary">
                    {paymentMethod === "online" ? "💳 Pay Online" : "💵 Cash on Delivery"}
                  </Typography>
                  <Typography variant="h6" fontWeight={800} color={TEAL}>₹{total}</Typography>
                </Box>
                <Button
                  variant="contained" disabled={loading} onClick={placeOrder}
                  sx={{ bgcolor: TEAL, textTransform: "none", px: 4, py: 1.2, borderRadius: 2 }}
                >
                  {loading ? <CircularProgress size={20} sx={{ color: "#fff" }} /> : (paymentMethod === "online" ? `Pay ₹${total} Now` : "Confirm Order")}
                </Button>
              </Stack>
            </Container>
          </Paper>
        </Box>
      )}
    </Container>
  );
};

const Confirmation = ({ order, onDone }) => (
  <Container maxWidth="sm" sx={{ py: 6, textAlign: "center" }}>
    <CheckCircleIcon sx={{ fontSize: 72, color: "#2e7d32" }} />
    <Typography variant="h5" fontWeight={800} mt={1}>Order Placed!</Typography>
    <Typography color="text.secondary" mb={3}>We'll pick up your laundry as scheduled.</Typography>
    <Paper variant="outlined" sx={{ p: 3, borderRadius: 3, textAlign: "left" }}>
      <Typography variant="caption" color="text.secondary">Order Code</Typography>
      <Typography variant="h6" fontWeight={800} color={TEAL} fontFamily="monospace" mb={2}>{order.order_code}</Typography>
      <Row label="Service" value={order.service_type} />
      <Row label="Pickup" value={`${order.pickup_date} · ${order.pickup_time}`} />
      <Row label="Delivery" value={`${order.delivery_date} · ${order.delivery_time}`} />
      <Row label="Total" value={`₹${order.total_amount}`} bold />
      <Row label="Payment" value={order.payment_status === "paid" ? "Paid" : "Pay on delivery"} />
    </Paper>
    <Button variant="contained" sx={{ mt: 3, bgcolor: TEAL, textTransform: "none" }} onClick={onDone}>Done</Button>
  </Container>
);

const Row = ({ label, value, bold }) => (
  <Box display="flex" justifyContent="space-between" py={0.5}>
    <Typography color="text.secondary">{label}</Typography>
    <Typography fontWeight={bold ? 800 : 600}>{value}</Typography>
  </Box>
);

export default LaundryBooking;